/*
 * TODO: Filters de-coffee & refactor: Consider move these action to useFilters hook and use it in:
 *
 *  * apps/publisher/javascripts/components/scheduled_events/filter_list/error_alert.coffee
 *  * apps/publisher/javascripts/components/scheduled_events/filter_list/index.coffee
 *  * apps/publisher/javascripts/components/scheduled_events/links/filter_by_event_type.coffee
 */
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { pickBy } from 'lodash-es'

export const setFiltersError = (type) => ({
  type: 'SET_FILTERS_ERROR',
  payload: {
    type
  }
})

export const clearFiltersError = () => ({
  type: 'CLEAR_FILTERS_ERROR'
})

export const selectAllFilterItems = (filterName) => (dispatch) => {
  dispatch(clearFiltersError())
  dispatch({
    type: 'SET_ALL_FILTER_ITEMS',
    payload: {
      name: filterName,
      selected: true
    }
  })
}

export const unselectAllFilterItems = (filterName) => (dispatch) => {
  dispatch(clearFiltersError())
  dispatch({
    type: 'SET_ALL_FILTER_ITEMS',
    payload: {
      name: filterName,
      selected: false
    }
  })
}

// Bootstrap Actions

const localBootstrap = () => ({
  status: {
    selected_items: [],
    groups: {
      collection: [{
        id: 0,
        type: 'status',
        key: 'status_0',
        name: I18n.t('publisher.dashboard.filters.status'),
        items: {
          collection: [{
            id: 'active',
            name: I18n.t('publisher.dashboard.filters.label.status.active_events_checkbox')
          },
          {
            id: 'canceled',
            name: I18n.t('publisher.dashboard.filters.label.status.canceled_events_checkbox')
          }
          ],
          pagination: {
            total_pages: 1,
            total_count: 1
          }
        }
      }
      ],
      pagination: {
        total_pages: 1,
        total_count: 1
      }
    }
  },
  host: {
    selected_items: [],
    groups: {
      collection: [{
        id: 0,
        type: 'host',
        key: 'host_0',
        name: I18n.t('publisher.dashboard.filters.label.host.host'),
        items: {
          collection: [{
            id: 'host',
            name: I18n.t('publisher.dashboard.filters.label.host.host')
          },
          {
            id: 'non_host',
            name: I18n.t('publisher.dashboard.filters.label.host.non_host')
          }
          ],
          pagination: {
            total_pages: 1,
            total_count: 1
          }
        }
      }
      ],
      pagination: {
        total_pages: 1,
        total_count: 1
      }
    }
  }
})

const getBootstrapResponseSelectedIds = (filterName, bootstrap, params) => {
  switch (filterName) {
    case 'status':
      return { status_0: params.status_ids }
    case 'host':
      return { host_0: params.host_ids }
    default:
      return bootstrap.selected_items.reduce((memo, item) => {
        const { key } = item.group
        return {
          ...memo,
          [key]: memo[key]
            ? [...memo[key], item.id]
            : [item.id]
        }
      },
      {})
  }
}

const buildBootstrapDoneAction = (filterName, bootstrap, params) => ({
  type: 'FETCH_FILTER_BOOTSTRAP_DONE',
  payload: {
    name: filterName,
    selected_items: bootstrap.selected_items,
    groups: bootstrap.groups,
    initial_selected_ids: getBootstrapResponseSelectedIds(filterName, bootstrap, params)
  }
})

const getTrackingParams = (params) => pickBy(params, (_, key) => key.startsWith('utm_'))

const getBootstrapRequestSelectedIds = (filterName, params, ids) => {
  switch (filterName) {
    case 'tracking':
      if (ids) return ids
      return getTrackingParams(params)

    case 'invitee_email':
      if (ids) return Object.values(ids).flat()
      return params[`${filterName}s`]

    default:
      if (ids) return Object.values(ids).flat()
      return params[`${filterName}_ids`]
  }
}

const getItemsRequestSelectedIds = (filterName, group, ids) => {
  switch (filterName) {
    case 'tracking':
      return ids[group.key]
    default:
      return Object.values(ids).flat()
  }
}

const fetchLocalBootstrap = (filterName, scope, params) => {
  if (!['status', 'host'].includes(filterName)) return null

  return buildBootstrapDoneAction(filterName, localBootstrap()[filterName], params)
}

const fetchRemoteBootstrap = (
  filterName,
  scope,
  params,
  term,
  withDeleted,
  initialPageSize,
  pageSize,
) => async (dispatch, getState) => {
  const filter = getState().filters[filterName]
  const selectedIds = getBootstrapRequestSelectedIds(
    filterName,
    params,
    filter && filter.selected_ids
  )

  dispatch({
    type: 'FETCH_FILTER_BOOTSTRAP_REQUEST',
    payload: {
      name: filterName
    }
  })

  const requestParams = {
    ...params,
    scope_type: scope.type,
    scope_id: scope.id,
    selected_ids: selectedIds,
    term: term || undefined,
    initial_page_size: initialPageSize,
    page_size: pageSize
  }

  if (withDeleted !== undefined) {
    requestParams.with_deleted = withDeleted
  }

  const [success, responseData] = await httpRequest({
    url: `/api/users/me/filters/${filterName}/bootstrap`,
    method: 'POST',
    data: requestParams
  })

  if (success) {
    const res = buildBootstrapDoneAction(filterName, responseData, params)
    dispatch(res)
  } else {
    dispatch({
      type: 'FETCH_FILTER_BOOTSTRAP_FAIL',
      payload: {
        name: filterName,
        error: responseData
      }
    })
  }
}

export const fetchFilterBootstrap = (filterName, scope, params, term, withDeleted, initialPageSize, pageSize) => {
  switch (filterName) {
    case 'status':
    case 'host':
      return fetchLocalBootstrap(filterName, scope, params)
    default:
      return fetchRemoteBootstrap(filterName, scope, params, term, withDeleted, initialPageSize, pageSize)
  }
}

export const fetchMoreFilterGroups = (userId, filterName, groups, scope, term) => async (dispatch, getState) => {
  const pageNumber = groups.pagination.next_page

  const selectedIds = Object.values(
    getState().filters[filterName].initial_selected_ids
  ).flat()

  dispatch({
    type: 'FETCH_FILTER_GROUPS_REQUEST',
    payload: {
      name: filterName,
      page: pageNumber
    }
  })

  const [success, responseData] = await httpRequest({
    url: `/api/users/${userId}/filters/${filterName}/groups`,
    params: {
      scope_type: scope.type,
      scope_id: scope.id,
      selected_ids: selectedIds,
      term: term ? encodeURIComponent(term) : undefined,
      page: pageNumber
    }
  })

  if (success) {
    dispatch({
      type: 'FETCH_FILTER_GROUPS_DONE',
      payload: {
        name: filterName,
        groups: responseData
      }
    })
  } else {
    dispatch({
      type: 'FETCH_FILTER_GROUPS_FAIL',
      payload: {
        name: filterName,
        error: responseData
      }
    })
  }
}

export const fetchMoreFilterItems = (
  userId,
  filterName,
  group,
  scope,
  params,
  term,
  withDeleted,
  initialPageSize,
  pageSize
) => async (dispatch, getState) => {
  const pageNumber = group.items.pagination.next_page

  const selectedIds = getItemsRequestSelectedIds(
    filterName,
    group,
    getState().filters[filterName].initial_selected_ids || {}
  )

  dispatch({
    type: 'FETCH_FILTER_ITEMS_REQUEST',
    payload: {
      name: filterName,
      page: pageNumber
    }
  })

  const requestParams = {
    ...params,
    scope_type: scope.type,
    scope_id: scope.id,
    group_type: group.type,
    group_id: group.id,
    selected_ids: selectedIds,
    term: term ? encodeURIComponent(term) : undefined,
    page: pageNumber,
    initial_page_size: initialPageSize,
    page_size: pageSize
  }

  if (withDeleted !== undefined) {
    requestParams.with_deleted = withDeleted
  }

  const [success, responseData] = await httpRequest({
    url: `/api/users/${userId}/filters/${filterName}/items`,
    params: requestParams
  })

  if (success) {
    dispatch({
      type: 'FETCH_FILTER_ITEMS_DONE',
      payload: {
        name: filterName,
        group,
        items: responseData
      }
    })
  } else {
    dispatch({
      type: 'FETCH_FILTER_ITEMS_FAIL',
      payload: {
        name: filterName,
        group,
        error: responseData
      }
    })
  }
}

export const clearFilterBootstrap = (filterName) => ({
  type: 'CLEAR_FILTER_BOOTSTRAP',
  payload: {
    name: filterName
  }
})
